import View from 'app/views/view';

export default class PageView extends View {
  static INITIALIZED = 'initialized';

  static LOADING = 'loading';

  static LOADED = 'loaded';

  isInitialized() {
    return this.status === PageView.INITIALIZED;
  }

  isLoading() {
    return this.status === PageView.LOADING;
  }

  isLoaded() {
    return this.status === PageView.LOADED;
  }

  isInitializedOrLoaded() {
    return this.isInitialized() || this.isLoaded();
  }
}
